import { ListChecks } from "lucide-react";
import { ManualeLayout, Scheda, P, Steps, Bullets, FAQ } from "@/pages/manuali/ManualeLayout";

const A = "#0891b2";
const SEZIONI = [
  { id: "intro", titolo: "A cosa serve" },
  { id: "dafare", titolo: "Da fare (agenda)" },
  { id: "attivita", titolo: "Attività & responsabili" },
  { id: "faq", titolo: "FAQ" },
];

export default function ManualeChiFaCosa() {
  return (
    <ManualeLayout titolo="Chi fa cosa" sottotitolo="Responsabilità e checklist ricorrenti dell'agenzia" icona={ListChecks} accent={A} sezioni={SEZIONI}>
      <Scheda id="intro" n="1" titolo="A cosa serve" accent={A}>
        <P>Definisce <b>chi è responsabile di cosa</b> e genera automaticamente le <b>checklist ricorrenti</b> (giornaliere, settimanali, mensili, una tantum), così nulla viene dimenticato.</P>
      </Scheda>

      <Scheda id="dafare" n="2" titolo="Da fare (agenda)" accent={A}>
        <P>La tab <b>Da fare</b> mostra le attività del momento raggruppate in <b>Oggi</b>, <b>Questa settimana</b>, <b>Questo mese</b> e <b>Una tantum</b>, con il responsabile e un badge del numero di voci ancora da completare.</P>
        <Bullets items={[
          "Spunta la casella per marcare un'attività come completata.",
          "Le attività ricorrenti si ripresentano automaticamente nel periodo successivo.",
        ]} />
      </Scheda>

      <Scheda id="attivita" n="3" titolo="Attività & responsabili" accent={A}>
        <Steps items={[
          "'Nuova attività': titolo e descrizione.",
          "Assegna Categoria (incassi, bonifici, quietanzamento, giornaliere, stipendi, subagenzia, assimoco, estratti, formazione, altro).",
          "Imposta la Ricorrenza; per 'settimanale' scegli il giorno, per 'una tantum' la scadenza.",
          "Indica il Responsabile e lascia 'Attiva' spuntata.",
        ]} />
      </Scheda>

      <Scheda id="faq" n="4" titolo="FAQ" accent={A}>
        <FAQ items={[
          { q: "Se sospendo un'attività sparisce dalle checklist?", a: "Sì: togli la spunta 'Attiva' e non comparirà più nell'agenda, senza essere eliminata." },
          { q: "Le spunte di oggi valgono anche domani?", a: "No: le attività ricorrenti si azzerano nel nuovo periodo, così la checklist riparte pulita." },
        ]} />
      </Scheda>
    </ManualeLayout>
  );
}
